import React from 'react'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import cn from 'classnames'
import classes from './Form.module.sass'

const Form = ({ defaultValues, children, onSubmit }) => {
  const methods = useForm({ defaultValues })
  const { handleSubmit } = methods

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {React.Children.map(children, (child) => (
        child.props.name ? (
          <div className={cn(classes.inputWrapper, child.props.containerClass)}>
            {React.createElement(child.type, {
              ...{
                ...child.props,
                register: methods.register,
                control: methods.control,
                key: child.props.name,
              },
            })}
          </div>
        ) : child
      ))}
    </form>
  )
}

Form.defaultProps = {
  defaultValues: {},
}

Form.propTypes = {
  defaultValues: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default Form
